import React, { useContext, useEffect, useState } from 'react';

import Context from '../../../store/context';

import classes from './Toast.module.scss';

const Toast = () => {
  const {
    toast: { content, visible }
  } = useContext(Context);

  const [showToast, setShowToast] = useState(visible);

  useEffect(() => {
    setShowToast(visible);
  }, [visible]);

  const classesContent = [classes.content];
  const classesContentBackground = [classes.background];
  if (visible) {
    classesContentBackground.push(classes['visible-background']);
  }
  if (showToast) {
    classesContent.push(classes.visible);
  }

  return (
    <div className={classesContentBackground.join(' ')}>
      <div className={classesContent.join(' ')}>{content}</div>
    </div>
  );
};

export default Toast;
